import React from 'react';
import {Route, Router} from "react-router";
import LoginApp from "./lib/login-app";
import {createBrowserHistory} from 'history';

const history = createBrowserHistory({});


function App() {
    const queryParams = window.location.search;
    const stage = process.env.REACT_APP_STAGE;
    return (
          <Router history={history}>
            <Route path={'/'} render={()=>
                <LoginApp stage={stage} queryParams={queryParams}/>}/>
          </Router>
      );
}

export default App;
